module.exports = __webpack_public_path__ + "img/s2_stepimg03-s.98c2c376.png";